let currentGroup = null;
let selectedTextObj = null;
let currentAlignmentIndex = 0;
let currentRotationAngle = 0;
let active_product = 0;


  //  const canvas = new fabric.Canvas('customizer-canvas', {
  //     preserveObjectStacking: true
  //   });

      // Preload the trash icon for reuse
    const deleteIconImg = document.createElement('img');
    deleteIconImg.src = 'https://cdn.shopify.com/s/files/1/0979/9316/3092/files/remove.png?v=1764140577';

    // Delete control setup
    // fabric.Object.prototype.controls.deleteControl = new fabric.Control({
    //   x: 0.5,
    //   y: -0.5,
    //   offsetY: -10,
    //   offsetX: 10,
    //   cursorStyle: 'pointer',
    //   mouseUpHandler: deleteObject,
    //   render: renderDeleteIcon,
    //   cornerSize: 24,
    //   touchCornerSize:150
    // });

    function deleteObject(eventData, transform) {
      const target = transform.target;
      console.log("target.customId",target);
      // remove_items_onjsoin(target.customId.split('_')[2]);
      canvas.remove(target);
      canvas.requestRenderAll();
    }
    
    function deleteObjectById(canvas,customId) {
      const obj = canvas.getObjects().find(o => o.customId === customId);
      if (obj) {
        canvas.remove(obj);
        canvas.requestRenderAll();        
      }
    }

    // Render delete icon exactly as requested
    function renderDeleteIcon(ctx, left, top, styleOverride, fabricObject) {
      const size = 20;
      const img = document.createElement('img');
      img.src = deleteIconImg.src;

      img.onload = function () {
        ctx.drawImage(img, left - 10, top - 10, size, size);
      };
      // Attempt to draw anyway in case it's cached
      ctx.drawImage(img, left - 10, top - 10, size, size);
    }


      function selectObjectById(canvas, customId) {
          canvas.discardActiveObject();
        const obj = canvas.getObjects().find(o => o.customId === customId);
        if (obj) {
          obj.set({
            selectable: true,
            evented: true,
            hasBorders: true,
            hasControls: true
          });
          canvas.setActiveObject(obj);
          canvas.bringToFront(obj);

          obj.setCoords();
          canvas.requestRenderAll();
        }
      }




       function setBackgroundFromURLSRC(canvas,url){
          if (!url) return;          
          var center = canvas.getCenter();
    
          fabric.Image.fromURL(url, function(img) {
            canvas.setBackgroundImage(img, canvas.renderAll.bind(canvas), {
              scaleX:0.9,
              scaleY:1,
              top: center.top,
              left: center.left,
              originX: 'center',
              originY: 'center',
              crossOrigin: 'anonymous'
            });
          }, { crossOrigin: 'anonymous' });
        }


        //  function setBackgroundFromURLSRCanovis(canvas, url) {
        //             if (!url) return;

        //             console.log("url", url);

        //             fabric.Image.fromURL(
        //               url,
        //               function (img) {
        //                 const canvasWidth = canvas.getWidth();
        //                 const canvasHeight = canvas.getHeight();

        //                 const scaleX = canvasWidth / img.width;
        //                 const scaleY = canvasHeight / img.height;

        //                 console.log("scaleX",scaleX);
        //                  console.log("scaleY",scaleY);
        //                     console.log("img.width",img.width,canvasWidth);
        //                  console.log("img.height",img.height,canvasHeight);
        //                  console.log("url",url)

        //                 canvas.setBackgroundImage(
        //                   img,
        //                   canvas.renderAll.bind(canvas),
        //                   {
        //                     scaleX: scaleX,
        //                     scaleY: scaleY,
        //                     left: 0,
        //                     top: 0,
        //                     originX: 'left',
        //                     originY: 'top'
        //                   }
        //                 );
        //               },
        //               {
        //                 crossOrigin: 'anonymous'
        //               }
        //             );
        // }


        function setBackgroundFromURLSRCanovis(canvas, url) {
          if (!url || !canvas) return;

          console.log("Background URL:", url);
          const canvasContainer = document.querySelectorAll(".canvas-container");

          // ------------------------------------
          // 1. Get SRDTyp value
          // ------------------------------------
          const srdTyp = Number(window.selected_data?.["SRDTyp"]) || 0;

          console.log("SRDTyp:", srdTyp);

          // ------------------------------------
          // 2. Remove all existing objects/groups
          // ------------------------------------
          canvas.getObjects().forEach(function (obj) {
            canvas.remove(obj);
          });

          // Remove existing background
          // canvas.setBackgroundImage(null, canvas.renderAll.bind(canvas));

          // // Clear active selection
          // canvas.discardActiveObject();

          // ------------------------------------
          // 3. Load new background image
          // ------------------------------------
          fabric.Image.fromURL(
            url,
            function (img) {
              if (!img) return;

              const imageWidth = img.width;
              const imageHeight = img.height;


              let canvasWidth;
              let canvasHeight;

              // ------------------------------------
              // 4. Canvas size logic
              // ------------------------------------
              if (srdTyp > 3) {
                // SRDTyp > 3
                canvasWidth = 1200;
                canvasHeight = 300;
              } else {
                // SRDTyp <= 3
                // Use original image dimensions
                canvasWidth = imageWidth;
                canvasHeight = imageHeight;
              }

              console.log("Image Size:", imageWidth, imageHeight);
              console.log("Canvas Size:", canvasWidth, canvasHeight);

              // ------------------------------------
              // 5. Update canvas dimensions
              // ------------------------------------
              canvas.setDimensions({
                width: canvasWidth,
                height: canvasHeight
              });
              canvasContainer.forEach(element => {
                if (element) {
                  element.style.width = canvasWidth + "px";
                  element.style.height = canvasHeight + "px";
                } 
              });
              
              // ------------------------------------
              // 6. Set image to EXACT canvas size
              // ------------------------------------
              img.set({
                width: canvasWidth,
                height: canvasHeight,
                scaleX: 1,
                scaleY: 1,
                left: 0,
                top: 0,
                originX: "left",
                originY: "top",
                selectable: false,
                evented: false
              });

              // ------------------------------------
              // 7. Set fresh background
              // ------------------------------------
              canvas.setBackgroundImage(
                img,
                function () {
                  canvas.discardActiveObject();
                  canvas.renderAll();

                  console.log("Fresh canvas ready");
                },
                {
                  left: 0,
                  top: 0,
                  originX: "left",
                  originY: "top"
                }
              );
            },
            {
              crossOrigin: "anonymous"
            }
          );
        }


        function uploadImageFromURL(canvas,url,object_con,slot_number = 0) {

          console.log("slot_number",slot_number);
          if(!canvas) return;
          console.log("object_con",object_con)
          console.log("object_con",object_con[0]);
          console.log("object_con_url",url);
                const uniqueId = `var_${Date.now()}`;
                let top_ = object_con[0].slotTop || 150; 
                let right_ = object_con[0].slotRight || 100;
                let width_  = object_con[0].slotWidth || 25;
                let height_  = object_con[0].slotHeight || 160;
                console.log("object_con_width_",width_,"hobject_con_width_eight_",height_);

                  if(slot_number > 0){
                        const RS_images_data  = getimage_json(slot_number);
                        console.log("RS_images_data",RS_images_data);
                            top_ = RS_images_data.top; 
                            right_ = RS_images_data.left;
                            width_  = RS_images_data.height || 47.43;
                            height_  = RS_images_data.width || 172;
                  }
                
                console.log("top;",top_,"right_",right_)          
                console.log("canvas",canvas);
                //  const objects = canvas.getObjects();
                if (!document.body.classList.contains('template-scadas-rs')) {
                        const textVal = window.CanvasText;
                        const font = 'Arial';
                        const color = '#000';
                        const objects = canvas?.getObjects?.() || [];
                        const target = objects?.find(obj => obj.customId === "first-text");
                          console.log("target",target,'objects',objects);

                        if (!target) {
                            function resizeTextbox(textObj) {
                                // jk
                                const ctx = canvas.getContext();
                                // const ctx = canvas?.getContext?.() || [];
                                // if (!ctx || typeof ctx.measureText !== "function") return;
                                //   // end
                              
                                    ctx.font = `${textObj.fontSize}px ${textObj.fontFamily}`;

                                    const newWidth = ctx.measureText(textObj.text).width + 20;

                                    textObj.set({
                                        width: newWidth,
                                        textAlign: 'center'
                                    });

                                    // handle Fabric 4 and 5
                                    if (textObj.initDimensions) textObj.initDimensions();
                                    if (textObj._initDimensions) textObj._initDimensions();                                             
                            }
                                      


                            // CREATE NEW TEXTBOX
                            const text = new fabric.Textbox(textVal, {
                                fontSize: 12,
                                fontFamily: font,
                                fill: color,
                                textAlign: 'center',
                                originX: 'center',  
                                originY: 'center',  
                                width: 150,
                                textBaseline: 'alphabetic',
                                selectable: false,
                                evented: false
                            });

                            console.log("text_FUN",text);
                            // jk
                            // const canvasWidth = canvas?.getWidth?.();
                            // if (!canvasWidth) return;
                            // end
                            resizeTextbox(text);

                            const group = new fabric.Group([text], {
                                // left: 100,
                                // top: 10,
                                originX: 'center',   // horizontal center
                                originY: 'top',      // top stays fixed
                                left: canvas.getWidth() / 2, // center horizontally
                                top: 10, 
                                subTargetCheck: true,
                                selectable: false,
                                evented: false
                            });

                            group.customId = 'first-text';
                            currentGroup = group;

                            canvas.add(group);
                            canvas.setActiveObject(group);
                            canvas.requestRenderAll();
                        }
              }else{
                if (slot_number == 1 || slot_number == 8 || slot_number == 14 || slot_number == 21 || slot_number == 27 ) {
                    const number_check =
                        slot_number == 1 ? 1 :
                        slot_number == 8 ? 2 :
                        slot_number == 14 ? 3 :
                        slot_number == 21 ? 4 :
                        slot_number == 27 ? 5 :
                        null;
                    const textVal = `${window.CanvasText} ${number_check}`;
                    const font = 'Arial';
                    const color = '#000000';
                    const font_color = '#000000';

                      const objects = canvas?.getObjects?.() || [];
                      const target = objects?.find(obj => obj.customId ===  textVal );


                            if (!target) {
                                function resizeTextbox(textObj) {
                                              // jk
                                              const ctx = canvas.getContext();
                                              // const ctx = canvas?.getContext?.() || [];
                                              // if (!ctx || typeof ctx.measureText !== "function") return;
                                              //   // end
                                           
                                                  ctx.font = `${textObj.fontSize}px ${textObj.fontFamily}`;
                                                  const newWidth = ctx.measureText(textObj.text).width + 20;
                                                  textObj.set({
                                                      width: newWidth
                                                  });

                                                  // handle Fabric 4 and 5
                                                  if (textObj.initDimensions) textObj.initDimensions();
                                                  if (textObj._initDimensions) textObj._initDimensions();                                             
                                          }
                                      


                                        // CREATE NEW TEXTBOX
                                        // Auto calculate font size based on image height/width
                                            // let autoFontSize = Math.min(height_,width_) * 0.15; // 15% of smaller dimension

                                           const text = new fabric.Textbox(textVal, {
                                                  fontSize: 15,
                                                  fontFamily: font,
                                                  fill: font_color,
                                                  textAlign: 'center',
                                                  width: 150,
                                                  left: 0,
                                                  top: 0,
                                                  originX: 'center',
                                                  originY: 'center'
                                              });

                                              text.setCoords();

                                              const rect = new fabric.Rect({
                                                  width: text.getScaledWidth() + 20,
                                                  height: text.getScaledHeight() + 20,
                                                  fill: '#fff',
                                                  stroke: color,
                                                  strokeWidth: 1,
                                                  rx: 10,
                                                  ry: 10,
                                                  left: 0,
                                                  top: 0,
                                                  originX: 'center',
                                                  originY: 'center'
                                              });
                                        // jk
                                        // const canvasWidth = canvas?.getWidth?.();
                                        // if (!canvasWidth) return;
                                        // end
                                        // resizeTextbox(text);

                                        const group = new fabric.Group([rect,text], {
                                           left: right_,
                                           top: 0,
                                           subTargetCheck: true,
                                            selectable: false,
                                            evented: false
                                        });

                                        group.lockMovementX = true;
                                        group.lockMovementY = true;
                                        group.hasControls = false;
                                        group.hasBorders = true;
                                        group.customId = textVal;
                                        currentGroup = group;

                                        canvas.add(group);
                                        canvas.setActiveObject(group);
                                        canvas.requestRenderAll();
                            }
                }
              }


                  const groupWidth = 188;
                 const groupHeight = 63.14;


              fabric.Image.fromURL(url, function (img) {
                console.log("img.width",img.width,img,url);


                 const originalWidth = img.width;
                 const originalHeight = img.height;

                // ✅ px → scale
                const scaleX = height_ / img.width;
                const scaleY = width_ / img.height;
                  console.log("originalWidth",originalWidth,"originalHeight",originalHeight);
                  console.log("height_",width_,"width_",height_);


                    const imageProperties = {
                        // left: right_,
                        // top: top_,

                        // left: right_ + 10,
                        // top: 0,
                         left: groupWidth / 2,
                         top: groupHeight / 2,
                        originX: 'center',
                        originY: 'center',

                        selectable: true,
                        hasControls: true,
                        hasBorders: true,

                        // 🔒 Lock resize
                        lockScalingX: true,
                        lockScalingY: true,
                        lockUniScaling: true,

                        // 🔒 Lock rotation
                        lockRotation: true,
                        // width = height_,
                        // height = width_ 
                      
                    };

                    if (document.body.classList.contains('template-scadas-rs') && originalWidth <= height_ ) {
                        // Set exact width/height
                        imageProperties.width = height_;
                        imageProperties.height = width_ ;
                    } else {
                        // Use scale for other templates
                        imageProperties.scaleX = scaleX;
                        imageProperties.scaleY = scaleY;
                    }


                    console.log("imageProperties",imageProperties,originalWidth,width_);
                     console.log("originalWidth",originalWidth,width_);
                     console.log("originalHeight",originalHeight,height_)
                   
                
                img.set(imageProperties);


                // const rect_ = new fabric.Rect({
                //                                   width: img.getScaledWidth(),
                //                                   height: img.getScaledHeight(),
                //                                   fill: '#fff',
                //                                   stroke: '#000',
                //                                   strokeWidth: 1,
                //                                   rx: 10,
                //                                   ry: 10,
                //                                   left: 0,
                //                                   top: 0,
                //                                   originX: 'center',
                //                                   originY: 'center'
                //                               });


                 console.log("originalWidth",originalWidth,"originalHeight",originalHeight);
                  console.log("height_",width_,"width_",height_);

                
                    // Group image and text together
                    const group = new fabric.Group([img], {
                      // left: img.left,
                      // top: img.top,
                      left: right_,
                      top: top_,
                      subTargetCheck: true,

                      width: groupWidth,
                      height: groupHeight,
                      

                      // lockMovementX: true,   // prevent moving
                      //   lockMovementY: true,
                      //   hasControls: false,    // optional (no resize/rotate handles)
                      //   hasBorders: true,   

                      // 🔒 lock scaling on group too
                        lockScalingX: true,
                        lockScalingY: true,
                        lockRotation: true    
                    }); 
                    
                    if (document.body.classList.contains('template-scadas-rs')) {
                          group.lockMovementX = true;
                          group.lockMovementY = true;
                          group.hasControls = false;
                          group.hasBorders = true;
                          group.subTargetCheck = true;
                          group.selectable = false;
                          group.evented = false;
                      }
                    
                      group.customId = uniqueId;
                      canvas.add(group);
                      canvas.setActiveObject(group);
                      currentGroup = group; 
                console.log("group",group);
              }, { crossOrigin: 'anonymous' });
              return uniqueId;
        }


        function uploadImageFromURLAnovis(canvas, url, slot_number = 0, totalProducts) {

                return new Promise((resolve, reject) => {

                    if (!canvas) {
                        reject(new Error("Canvas not found"));
                        return;
                    }

                    const uniqueId = `var_${Date.now()}_${Math.random()}`;

                    if (!slot_number) {
                        reject(new Error("Invalid slot number"));
                        return;
                    }

                    const img_properties = get_canvas_position(
                        slot_number,
                        totalProducts,
                        canvas
                    );

                    let top_ = img_properties.top + 5;
                    let right_ = img_properties.left;
                    let width_ = img_properties.width || 15;
                    let height_ = img_properties.height || 300;

                    // console.log(
                    //     "img_properties",
                    //     img_properties,
                    //     "url",
                    //     url
                    // );

                    const textVal = `${slot_number}`;
                    const textVal_id = `text_${slot_number}`;
                    const font = 'Arial';
                    const color = '#000000';
                    const font_color = '#ffffffff';

                    const objects = canvas?.getObjects?.() || [];

                    const target = !!objects?.find(
                        obj => obj.customId === textVal_id
                    );

                    // console.log("target", target);

                    // ==========================================
                    // IMAGE LOAD
                    // ==========================================

                    fabric.Image.fromURL(
                        url,
                        function (img) {

                            try {

                                // console.log("img.width", img.width, img);

                                const originalWidth = img.width;
                                const originalHeight = img.height;

                                const scaleX = width_ / originalWidth;
                                const scaleY = (height_ / originalHeight) - 0.01;

                                // console.log(
                                //     "width_",
                                //     width_,
                                //     "height_",
                                //     height_
                                // );

                                // console.log(
                                //     "originalWidth",
                                //     originalWidth,
                                //     "originalHeight",
                                //     originalHeight,
                                //     "scaleX",
                                //     scaleX,
                                //     "scaleY",
                                //     scaleY
                                // );

                                const imageProperties = {
                                    left: right_,
                                    top: top_,
                                    selectable: true,
                                    hasControls: true,
                                    hasBorders: true,
                                    lockScalingX: true,
                                    lockScalingY: true,
                                    lockUniScaling: true,
                                    lockRotation: true,

                                    scaleX: scaleX,
                                    scaleY: scaleY
                                };

                                img.set(imageProperties);

                                // ==========================================
                                // IMAGE GROUP
                                // ==========================================

                                const imageGroup = new fabric.Group([img], {
                                    left: img.left,
                                    top: img.top,
                                    subTargetCheck: true,
                                    lockScalingX: true,
                                    lockScalingY: true,
                                    lockRotation: true
                                });

                                imageGroup.lockMovementX = true;
                                imageGroup.lockMovementY = true;
                                imageGroup.hasControls = false;
                                imageGroup.hasBorders = true;
                                imageGroup.subTargetCheck = true;
                                imageGroup.selectable = false;
                                imageGroup.evented = false;

                                imageGroup.customId = uniqueId;

                                // Add image group
                                canvas.add(imageGroup);

                                currentGroup = imageGroup;

                                // ==========================================
                                // YOUR OTHER CODE HERE
                                // ==========================================

                                /*
                                Your textGenrate() code can stay here.
                                */

                                canvas.requestRenderAll();

                                // console.log("imageGroup added", imageGroup);

                                // ==========================================
                                // IMPORTANT
                                // IMAGE IS NOW COMPLETED
                                // ==========================================

                                resolve(uniqueId);

                            } catch (error) {

                                console.error(
                                    "Error while processing image:",
                                    error
                                );

                                reject(error);
                            }

                        },
                        {
                            crossOrigin: 'anonymous'
                        }
                    );

                });
            }


      function uploadImageFromURLES(canvas,url,object_con,slot_number = 0,occcupied_slot) {

          console.log("slot_number",slot_number);
          if(!canvas) return;

                const uniqueId = `var_${Date.now()}`;
                let top_ = object_con[0].slotTop || 150; 
                let right_ = object_con[0].slotRight || 100;
                let width_  = object_con[0].slotWidth || 25;
                let height_  = object_con[0].slotHeight || 160;
              

                  if(slot_number > 0){
                        const RS_images_data  = getimage_jsonES(slot_number,occcupied_slot);
                        console.log("RS_images_data",RS_images_data);
                            top_ = RS_images_data.top; 
                            right_ = RS_images_data.left;
                            height_  = RS_images_data.width || 47.43;
                            width_  = RS_images_data.height || 172;
                  }
                
                console.log("top;",top_,"right_",right_)          
                console.log("canvas",canvas);
                //  const objects = canvas.getObjects();
                
                if (slot_number == 1 || slot_number == 10 ) {
                    const number_check =
                        slot_number == 1 ? 1 :
                        slot_number == 10 ? 2 :
                        null;
                    const textVal = `${window.CanvasText} ${number_check}`;
                    const font = 'Arial';
                    const color = '#000000';
                    const font_color = '#000000';

                    const canvasWidth = window.canvas.getWidth();
                    const tenPercentWidth = canvasWidth * 0.10;

                   
                    


                      const objects = canvas?.getObjects?.() || [];
                      const target = objects?.find(obj => obj.customId ===  textVal );


                            if (!target) {
                                function resizeTextbox(textObj) {
                                              // jk
                                              const ctx = canvas.getContext();
                                              // const ctx = canvas?.getContext?.() || [];
                                              // if (!ctx || typeof ctx.measureText !== "function") return;
                                              //   // end
                                           
                                                  ctx.font = `${textObj.fontSize}px ${textObj.fontFamily}`;
                                                  const newWidth = ctx.measureText(textObj.text).width + 20;
                                                  textObj.set({
                                                      width: newWidth
                                                  });

                                                  // handle Fabric 4 and 5
                                                  if (textObj.initDimensions) textObj.initDimensions();
                                                  if (textObj._initDimensions) textObj._initDimensions();                                             
                                          }
                                      


                                        // CREATE NEW TEXTBOX
                                        // Auto calculate font size based on image height/width
                                            // let autoFontSize = Math.min(height_,width_) * 0.15; // 15% of smaller dimension

                                           const text = new fabric.Textbox(textVal, {
                                                  fontSize: 13,
                                                  fontFamily: font,
                                                  fill: font_color,
                                                  textAlign: 'center',
                                                  width: (tenPercentWidth - 10),
                                                  left: 0,
                                                  top: top_,
                                                  originX: 'center',
                                                  originY: 'center'
                                              });

                                              text.setCoords();

                                              const rect = new fabric.Rect({
                                                  width: text.getScaledWidth() + 10,
                                                  height: text.getScaledHeight() + 10,
                                                  fill: '#fff',
                                                  stroke: color,
                                                  strokeWidth: 1,
                                                  rx: 10,
                                                  ry: 10,
                                                  left: 0,
                                                  top: top_,
                                                  originX: 'center',
                                                  originY: 'center'
                                              });
                                        // jk
                                        // const canvasWidth = canvas?.getWidth?.();
                                        // if (!canvasWidth) return;
                                        // end
                                        // resizeTextbox(text);

                                        const group = new fabric.Group([rect,text], {
                                           left: 10,
                                           top: top_,
                                           subTargetCheck: true,
                                            selectable: false,
                                            evented: false,
                                             width: tenPercentWidth,
                                             height:width_
                                        });

                                        group.lockMovementX = true;
                                        group.lockMovementY = true;
                                        group.hasControls = false;
                                        group.hasBorders = true;
                                        group.customId = textVal;
                                        currentGroup = group;

                                        console.log("Actual Width:", group.getScaledWidth());
                                        console.log("Actual Height:", group.getScaledHeight());


                                        canvas.add(group);
                                        canvas.setActiveObject(group);
                                        canvas.requestRenderAll();
                            }
                }
              

                console.log("width_",width_,"height_",height_);
                  const groupWidth = height_;
                 const groupHeight = width_;

                  
                            


              fabric.Image.fromURL(url, function (img) {
                console.log("img.width",img.width,img,url);


                 const originalWidth = img.width;
                 const originalHeight = img.height;

                // ✅ px → scale
                const scaleX = height_ / img.width;
                const scaleY = width_ / img.height;
                  console.log("originalWidth",originalWidth,"originalHeight",originalHeight);
                  console.log("height_",width_,"width_",height_);


                    const imageProperties = {

                         left: groupWidth / 2,
                         top: groupHeight / 2,
                        originX: 'center',
                        originY: 'center',

                        selectable: true,
                        hasControls: true,
                        hasBorders: true,

                     
                        lockScalingX: true,
                        lockScalingY: true,
                        lockUniScaling: true,

     
                        lockRotation: true,

                      
                    };

                    if (document.body.classList.contains('template-scadas-rs') && originalWidth <= height_ ) {
                        // Set exact width/height
                        imageProperties.width = height_;
                        imageProperties.height = width_ ;
                    } else {
                        // Use scale for other templates
                        imageProperties.scaleX = scaleX;
                        imageProperties.scaleY = scaleY;
                    }


                    console.log("imageProperties",imageProperties,originalWidth,width_);
                     console.log("originalWidth",originalWidth,width_);
                     console.log("originalHeight",originalHeight,height_)
                   
                
                img.set(imageProperties);



                 console.log("originalWidth",originalWidth,"originalHeight",originalHeight);
                  console.log("height_",width_,"width_",height_);

                
                    // Group image and text together
                    const group = new fabric.Group([img], {
                      // left: img.left,
                      // top: img.top,
                      left: right_,
                      top: top_,
                      subTargetCheck: true,

                      width: groupWidth,
                      height: groupHeight,
                      

                      
                        lockScalingX: true,
                        lockScalingY: true,
                        lockRotation: true    
                    }); 
                    
                    
                          group.lockMovementX = true;
                          group.lockMovementY = true;
                          group.hasControls = false;
                          group.hasBorders = true;
                          group.subTargetCheck = true;
                          group.selectable = false;
                          group.evented = false;
                      
                    
                      group.customId = uniqueId;
                      canvas.add(group);
                      canvas.setActiveObject(group);
                      currentGroup = group; 
                console.log("group",group);
              }, { crossOrigin: 'anonymous' });
              return uniqueId;
        }





            function canvasSet(url){
              if(document.body.classList.contains('template-scadas-rs') && document.body.classList.contains('template-anovis-configuration-plan')){
                  window.canvas = new fabric.Canvas('customizer-canvas', {
                      preserveObjectStacking: true,
                      selection: false,
                      skipTargetFind: true
                  });
                }else{
                    window.canvas = new fabric.Canvas('customizer-canvas', {
                      preserveObjectStacking: true
                    });
                }
            
              if(url){
                if(document.body.classList.contains('template-anovis-configuration-plan')){
                setBackgroundFromURLSRCanovis(window.canvas,url)
                }else{
                setBackgroundFromURLSRC(window.canvas,url)
                }
              }

              select_canvo(window.canvas);

             }


             function select_canvo(canvas) {
             canvas.on('mouse:down', function (opt) {
                        const main_selecter =  document.querySelectorAll(`.meta-slot-input[data-canvas-group-id]`) || null;
                        main_selecter.forEach(el => {
                          el.classList.remove('active');
                        });
                          const target = opt.target;
                           if (target && target.type == 'group') {
                            const main_selecter_ =  document.querySelectorAll(`.meta-slot-input[data-canvas-group-id=${target.customId}]`) || null;
                            main_selecter_.forEach(el => {
                              console.log("el",el);
                              el.classList.add('active');
                            });
                          }
                })     
             }



            function mainSlotHover(This) {
              // console.log("This",This);
              const main_selecter =  document.querySelectorAll(`.meta-slot-input[data-canvas-group-id]`) || null;
                main_selecter.forEach(el => {
                  el.classList.remove('active');
                });
              const get_image_attr = This?.querySelector('input')?.getAttribute(`data-canvas-group-id`) || null;  
              // console.log("get_image_attr",get_image_attr)
                if(get_image_attr){
                  This.querySelector('[data-canvas-group-id]')?.classList.add('active');
                  selectObjectById(window.canvas,get_image_attr);
                }
            }


             function select_canvo_main(customId) {
              const main_selecter =  document.querySelectorAll(`.meta-slot-input[data-canvas-group-id]`) || null;
                        main_selecter.forEach(el => {
                          el.classList.remove('active');
                        });
             }



             async  function deleteObjectById_custom(canvas) {
                  const obj = canvas.getObjects().find(o => o.customId === 'first-text');
                  if (obj) {
                    canvas.remove(obj);
                    canvas.requestRenderAll();        
                  }
                   return canvas; // 
                }


            async  function canvasimagecheck(){

              window.canvas = await  deleteObjectById_custom(window.canvas)
              console.log("window.canvas",window.canvas);
                    if(window.canvas){
                      const pngBase64 = window.canvas.toDataURL({
                        format: 'png',
                        multiplier: 2
                      });                  
                      const new_url = await updateimage(pngBase64);
                      console.log("new_url",new_url); 
                      window.canvasfinalimagesrc = new_url;

                          if(window.canvasfinalimagesrc){
                            const image_filds = document.querySelector('[data-slot-main-image]') || null;
                              if(image_filds) image_filds.value = window.canvasfinalimagesrc;
                            
                               localStorage.setItem("show_image_main", JSON.stringify(window.canvasfinalimagesrc)); 

                              const progress_bar = document.querySelectorAll(".progressbar_image");
                                progress_bar?.forEach(function(bar){
                                  const image_bar = bar.querySelector("img");          
                                  if(image_bar) image_bar.src = window.canvasfinalimagesrc;    
                                });                         
                                const show_image = document.querySelector(".show_image_main") || null;
                                 if(show_image){
                                  const wrapper = document.createElement("div");
                                    wrapper.className = "selected_product_show";
                                    wrapper.innerHTML = `
                                      <div class="image">
                                        <img src="${window.canvasfinalimagesrc}" 
                                            alt="product-image-canvas" 
                                            loading="lazy" />
                                      </div>
                                    `; 
                                show_image.appendChild(wrapper);   
                                 }                
                          }
                     }
             }


            if(document.body.classList.contains('template-scadas-rs') || document.body.classList.contains('template-scadas-es')){
              canvasSet();             
              // window.limit = 5;
            }


function getimage_json(imageNumber) {
    if (!window.canvas) return null;

    const canvasWidth = window.canvas.getWidth();
    const canvasHeight = window.canvas.getHeight();

    const columns = 5;
    const columnGap = 10;
    const sidePadding = 10; // Left & Right space
    const baseTopOffset = 50;

    const col1Rows = 7;
    const otherRows = 6;

    // Include left and right padding
    const totalGap = (columns - 1) * columnGap;
    const availableWidth = canvasWidth - totalGap - (sidePadding * 2);

    const colWidth = availableWidth / columns;

    const col1Height = (canvasHeight - baseTopOffset) / col1Rows;

    const otherStartTop = baseTopOffset + col1Height;
    const otherHeight = (canvasHeight - otherStartTop) / otherRows;

    let currentIndex = 1;

    for (let col = 0; col < columns; col++) {

        const isFirstCol = col === 0;

        const rows = isFirstCol ? col1Rows : otherRows;
        const cellHeight = isFirstCol ? col1Height : otherHeight;

        // Start from left padding
        const left = sidePadding + (col * (colWidth + columnGap));

        const topOffset = isFirstCol
            ? baseTopOffset
            : otherStartTop;

        for (let row = 0; row < rows; row++) {

            if (currentIndex === imageNumber) {

                const top = topOffset + (row * cellHeight);

                return {
                    top: +top.toFixed(2),
                    left: +left.toFixed(2),
                    width: +colWidth.toFixed(2),
                    height: +cellHeight.toFixed(2)
                };
            }

            currentIndex++;
        }
    }

    return null;
}
function getimage_jsonES(imageNumber, columnSpan = 1) {
  // columnSpan = 1;
  if (!window.canvas) return null;

  const canvasWidth = window.canvas.getWidth();
  const canvasHeight = window.canvas.getHeight();

  const slotsPerRow = 10;
  const totalSlots = 20;
  const columnGap = 10;

    const sidePadding = canvasWidth * 0.15;
  const rightPadding = 10;

  
  // const sidePadding = 145; // Skip first 145px
  const rowGap = 20; // Space between row 1 and row 2
   const rowHeight = (canvasHeight - rowGap) / 2;

  if (
    !Number.isInteger(imageNumber) ||
    imageNumber < 1 ||
    imageNumber > totalSlots ||
    !Number.isInteger(columnSpan) ||
    columnSpan < 1 ||
    columnSpan > slotsPerRow
  ) {
    return null;
  }

  const totalUnits = 10;
  const totalGaps = (slotsPerRow - 1) * columnGap;

  const availableWidth =
    canvasWidth - sidePadding - 10 - totalGaps;

  const unitWidth = availableWidth / totalUnits;

  const row = Math.floor((imageNumber - 1) / slotsPerRow);
  const slotInRow = (imageNumber - 1) % slotsPerRow;

  let left = sidePadding;

  for (let i = 0; i < slotInRow; i++) {
    const slotNumber = row * slotsPerRow + i + 1;

    console.log("slotNumber",slotNumber);

    const units = slotNumber === 1 || slotNumber === 10 ? 1 : 1;

    left += unitWidth * units + columnGap;
    // if(slotNumber === 10)  left = sidePadding;
  }


  const width = unitWidth * columnSpan;

  return {
     top: Math.round(row * (rowHeight + rowGap)),
    left: Math.round(left),
    width: Math.round(width),
    height: Math.round(rowHeight)
  };
}

 function resizeTextbox(textObj, canvas) {
    const ctx = canvas.getContext();

    ctx.font = `${textObj.fontSize}px ${textObj.fontFamily}`;

    const newWidth =
        ctx.measureText(textObj.text).width + 5;

    textObj.set({
        width: newWidth
    });

    if (textObj.initDimensions) {
        textObj.initDimensions();
    }

    if (textObj._initDimensions) {
        textObj._initDimensions();
    }
}


function textGenrate(canvas , img_properties, leftPersentage, topPersentage, textVal, font_color, fillColor,caculat_top = false ){
  if( typeof textVal == 'undefined') return;
    const font = 'Arial';
    const color = '#000000';

    let top_ = img_properties.top;
    let right_ = img_properties.left;
    let width_ = img_properties.width;
    let height_ = img_properties.height;
    const textVal_id = `text_${textVal}`;

    let textLeft =  right_  + (width_ * leftPersentage);
    let textTop = top_ + (height_ * topPersentage);
   

    // console.log("renderedWidth", renderedWidth);
    // console.log("renderedHeight", renderedHeight);
    console.log("textLeft", textLeft);
    console.log("textTop", textTop);
    console.log("textVal", textVal);

    // CREATE TEXT
    const text = new fabric.Textbox(textVal, {
        fontSize: 14,
        fontFamily: font,
        fill: font_color,
        textAlign: 'center',
        width: 15,

        left: 0,
        top: 0,

        originX: 'center',
        originY: 'center'
    });
    
    resizeTextbox(text, canvas);

    text.setCoords();

    const size = Math.max(
        text.getScaledWidth(),
        text.getScaledHeight()
    ) + 10;

    // CREATE BLUE CIRCLE
    const circle = new fabric.Circle({
        radius: size / 2,

        fill: fillColor,
        stroke: color,
        strokeWidth: 1,

        left: 0,
        top: 0,

        originX: 'center',
        originY: 'center'
    });

    // ------------------------------------------
    // GROUP TEXT + CIRCLE
    // ------------------------------------------

    if(caculat_top){
      const addonPercentage = (size / 2) / height_;
      console.log("addonPercentage",addonPercentage,"height_",height_,"size",size,"(topPersentage * 2)",(topPersentage * 2));
      topPersentage = (topPersentage * 2) + addonPercentage;
    textTop = top_ + (height_ * topPersentage);
    
    }
    console.log("caculat_top",caculat_top, "textTop" , textTop,"topPersentage",topPersentage);
  


    const textGroup = new fabric.Group(
        [circle, text],
        {
            left: textLeft,
            top: textTop,

            originX: 'center',
            originY: 'center',

            subTargetCheck: true,

            selectable: false,
            evented: false,

            lockMovementX: true,
            lockMovementY: true,
            hasControls: false,
            hasBorders: true
        }
    );

    // textGroup.lockMovementX = true;
    // textGroup.lockMovementY = true;
    // textGroup.hasControls = false;
    // textGroup.hasBorders = true;
    textGroup.customId = textVal_id;

    currentGroup = textGroup;

    canvas.add(textGroup);
    // canvas.setActiveObject(textGroup);
    canvas.requestRenderAll();

}